export const convertBytesToGigabytes = (bytes: number): number => {
    const gigabytes = bytes / Math.pow(1024, 3);
    return Number.parseFloat(gigabytes.toFixed(2));
}

export const convertBytesToStringGigabytes = (bytes: number): string => {
    return `${convertBytesToGigabytes(bytes)} GB`;
}